const SQFT_RE = /(\d{1,2},?\d{3}|\d{2,5})\s*(sq\.?\s*f(ee)?t|square\s*f(oo|ee)t|sf\b|sqft|ft²|ft2)/i;
const DIM_RE = /(\d{1,2}(?:\.\d)?)\s*(?:'|ft|feet)?\s*(?:x|by|×)\s*(\d{1,2}(?:\.\d)?)\s*(?:'|ft|feet)?/i;
const STOREY_RE = /\b(second|2nd|third|3rd|upper|another|extra|new)[\s-]+(storey|story|floor|level)\b(?![-\s]*(lamp|to|tile|plan|bath|bed|laundry))|\b(two|2|three|3)[\s-]+(storey|story|level)s?\b|\badd (a |an |another )?(level|storey|story)\b|\badd (a |an |another )?floor\s*($|on top|above|upstairs)/i;
const SHRINK_RE = /\b(smaller|reduce|shrink|remove|delete|drop|less)\b/i;
const num = (s) => Number(String(s).replace(",", ""));

/** Rough projection of a revision's total area, from the wording of the request. */
export function estimateRevision(text, plan) {
  if (!plan || !text.trim()) return null;
  const now = plan.total_area;
  const footprint = plan.width * plan.depth;
  const t = text.toLowerCase();
  let total = now, basis = "";
  const sq = t.match(SQFT_RE);
  const dim = t.match(DIM_RE);
  if (sq && /\b(make it|total|overall|whole|house|home|resize to|grow to|expand to)\b/.test(t)) {
    total = num(sq[1]); basis = `${num(sq[1]).toLocaleString()} sq ft total`;
  } else if (sq && /\badd|extra|new|bigger|plus\b/.test(t)) {
    total = now + num(sq[1]); basis = `+${num(sq[1]).toLocaleString()} sq ft`;
  } else if (dim && /\badd|extra|new\b/.test(t)) {
    const a = Number(dim[1]) * Number(dim[2]);
    total = now + a; basis = `+${dim[1]}×${dim[2]} ft room`;
  } else if (STOREY_RE.test(t) && !SHRINK_RE.test(t) && plan.floors.length < 4) {
    total = now + footprint; basis = "another storey";
  } else if (/\b(garage)\b/.test(t) && /\badd\b/.test(t)) {
    total = now + (/\b(3|three)[\s-]*car\b/.test(t) ? 720 : /\b(1|one|single)[\s-]*car\b/.test(t) ? 260 : 480); basis = "garage";
  } else if (/\b(add|another|extra|new)\s+(an?\s+)?(extra\s+|new\s+|another\s+)?(\w+\s+)?(bedroom|office|room|suite|den)\b/.test(t) && !/\bwindows?\b/.test(t)) {
    total = now + 150; basis = "an extra room";
  } else if (/\b(bigger|larger|expand|enlarge|extend)\b/.test(t)) {
    total = now * 1.04; basis = "a few % larger";
  } else {
    basis = "same size";
  }
  return { total: Math.round(total), basis };
}

export function revisionCost(est, licensed) {
  if (!est) return null;
  const limit = licensed * 1.05 + 1;
  const extra = est.total > limit ? Math.ceil(est.total - licensed) : 0;
  return { ...est, extra, cost: extra };
}
